import {useCallback} from "react";
import lscache from "lscache";

import {clearPhoneVerificationTimerLS} from "@pg-mono/user";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {useAfterAuthRedirect} from "../../../auth/hooks/use_after_auth_redirect";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../../km_app/constants/storage_keys";
import {selectOpenRegistrationPhoneNumberModal, selectRegistrationPhoneNumberModalLocation} from "../../state/user_phone_verification_slice";
import {PhoneVerificationPendingActionType} from "../types/phone_verification_types";
import {completeRegistrationOnboarding, requestRegistrationOnboardingPhoneVerification} from "../utils/complete_registration_onboarding";
import {usePhoneVerificationActionCompletion} from "./use_phone_verification_action_completion";

interface IUseRegistrationOnboardingPhoneOptions {
    beginSkipUpdatePhonePrompt: () => void;
    refetchUserProfile: () => void;
}

export const useRegistrationOnboardingPhone = (props: IUseRegistrationOnboardingPhoneOptions) => {
    const {beginSkipUpdatePhonePrompt, refetchUserProfile} = props;

    const dispatch = useAppDispatch();
    const onAfterRegister = useAfterAuthRedirect();
    const isOpen = useAppSelector(selectOpenRegistrationPhoneNumberModal);
    const location = useAppSelector(selectRegistrationPhoneNumberModalLocation);

    const completeOnboarding = useCallback(() => completeRegistrationOnboarding(dispatch, onAfterRegister), [dispatch, onAfterRegister]);

    usePhoneVerificationActionCompletion({
        actionType: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING,
        onComplete: completeOnboarding,
        onDismissed: completeOnboarding
    });

    return {
        isOpen,
        onClose: completeOnboarding,
        onSuccess: () => {
            if (!location) return;

            clearPhoneVerificationTimerLS();
            beginSkipUpdatePhonePrompt();
            lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
            requestRegistrationOnboardingPhoneVerification(dispatch, location);
            void refetchUserProfile();
        }
    };
};
import {useCallback} from "react";
import lscache from "lscache";

import {clearPhoneVerificationTimerLS} from "@pg-mono/user";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {useAfterAuthRedirect} from "../../../auth/hooks/use_after_auth_redirect";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../../km_app/constants/storage_keys";
import {selectOpenRegistrationPhoneNumberModal, selectRegistrationPhoneNumberModalLocation} from "../../state/user_phone_verification_slice";
import {PhoneVerificationPendingActionType} from "../types/phone_verification_types";
import {completeRegistrationOnboarding, requestRegistrationOnboardingPhoneVerification} from "../utils/complete_registration_onboarding";
import {usePhoneVerificationActionCompletion} from "./use_phone_verification_action_completion";

interface IUseRegistrationOnboardingPhoneOptions {
    beginSkipUpdatePhonePrompt: () => void;
    refetchUserProfile: () => void;
}

export const useRegistrationOnboardingPhone = (props: IUseRegistrationOnboardingPhoneOptions) => {
    const {beginSkipUpdatePhonePrompt, refetchUserProfile} = props;

    const dispatch = useAppDispatch();
    const onAfterRegister = useAfterAuthRedirect();
    const isOpen = useAppSelector(selectOpenRegistrationPhoneNumberModal);
    const location = useAppSelector(selectRegistrationPhoneNumberModalLocation);

    const completeOnboarding = useCallback(() => completeRegistrationOnboarding(dispatch, onAfterRegister), [dispatch, onAfterRegister]);

    usePhoneVerificationActionCompletion({
        actionType: PhoneVerificationPendingActionType.REGISTRATION_ONBOARDING,
        onComplete: completeOnboarding,
        onDismissed: completeOnboarding
    });

    return {
        isOpen,
        onClose: completeOnboarding,
        onSuccess: () => {
            if (!location) return;

            clearPhoneVerificationTimerLS();
            beginSkipUpdatePhonePrompt();
            lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
            requestRegistrationOnboardingPhoneVerification(dispatch, location);
            void refetchUserProfile();
        }
    };
};
